import { BasemapOptionEntity } from '@gishub/domain';
import { IBasemapSourceStrategy } from './i-basemap-source-strategy';
import { IBasemapSourceStrategyConfig } from './i-basemap-source-strategy-config';

export class VectorBasemapStrategy implements IBasemapSourceStrategy {
  createConfig(option: BasemapOptionEntity): IBasemapSourceStrategyConfig {
    return {
      urlTemplate: option.urlTemplate,
      subDomains: option.subDomains,
      attribution: option.attribution,
      type: 'vector',
    };
  }
}
